import * as React from 'react'
import Helmet from 'react-helmet'
import { Link } from 'react-router-dom'

import ga from '../../common/utils/ga'
import { getCurrentSiteDomain } from '../../common/utils/sites'
import AmGrid from '../components/amGrid'
import SearchIcon from '../components/icons/search'
import SearchBarForm from '../components/searchBar/searchBarForm'
import SearchBarInput from '../components/searchBar/searchBarInput'

import { Props } from '../containers/notFoundPageContainer'

const NotFoundPage = ({ location, currentSite, makeSearchLink }: Props) => {
  ga('send', 'event', {
    eventCategory: '404',
    eventAction: `https://${getCurrentSiteDomain(currentSite)}/404`
  })
  const pageTitle = `Page Not Found | ${currentSite}`

  return (
    <section className="page-section">
      <div className="grid-container">
        <Helmet title={pageTitle} />
        <header className="fds-u-text-align-center">
          <h1 className="fds-c-text-heading -size-xxl">
            404 - Nothing to see here
          </h1>
          <h2 className="fds-c-text-body -size-xl">
            Just kidding. There&apos;s plenty to see on {currentSite}. Why not<br className="fds-u-hide-medium-and-below" />{' '}
            try a search, or take a look at our{' '}
            <Link
              className="fds-c-text-link -decoration-reversed"
              to="/page/top_sellers"
            >
              Popular files
            </Link>?
          </h2>
        </header>
        <AmGrid am-grid className="fds-u-my2">
          <AmGrid
            am-grid-col="l:8 l:pre2 m:6 m:pre1"
            am-grid-row="m:start m:end l:start l:end"
          >
            <SearchBarForm
              makeSearchLink={makeSearchLink}
              className="search-field -size-xl"
            >
              <div style={{ margin: 0, padding: 0, display: 'inline' }}>
                <input name="utf8" type="hidden" value="✓" />
              </div>

              <div className="search-field__input">
                <SearchBarInput
                  value={location.query.term}
                  className="search-field__input-field"
                  name="term"
                  placeholder="e.g. responsive wordpress"
                />
              </div>

              <button
                className="fds-c-button search-field__button"
                type="submit"
              >
                <SearchIcon />
              </button>
            </SearchBarForm>
          </AmGrid>
        </AmGrid>
      </div>
    </section>
  )
}

export default NotFoundPage
